import { Injectable } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase/app';
import { Observable } from 'rxjs/Observable';
// import { Router } from '@angular/router';

@Injectable()
export class AuthService {

	private authState: Observable<firebase.User>
  private currentUser: firebase.User = null;

  constructor(
    public afAuth: AngularFireAuth
    // public router: Router
   ) {
  	
  	this.authState = this.afAuth.authState;
    this.authState.subscribe(user => {
      if (user) {
        this.currentUser = user;
      } else {
        this.currentUser = null;
      }
    });
  }

  getAuthState() {
    return this.authState;
  }

  loginWithGithub() {
    return this.afAuth.auth.signInWithPopup(
    	new firebase.auth.GithubAuthProvider().addScope("public_repo"));
  }

  logout(){
      console.log("user is logging out...")
      return this.afAuth.auth.signOut();
  }

}



// WEBPACK FOOTER //
// ./src/app/services/auth.service.ts